import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Link } from 'gatsby'
import { capitalizeWord } from '../helpers/slug'
import lang from '../../static/lang.json'
import LocaleContext from './Locale'
import vars from '../lib/styled'

const BreadCrumbsList = styled.ul`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  list-style: none;
  margin: 0 0 0;
  padding: 0;

  li,
  a {
    font-size: 0.79rem;
  }
`

const BreadCrumbItem = styled.li`
  color: ${vars.primary};
  margin: 0 0.5rem;

  a {
    text-decoration: underline;
  }
`
const formatCrumb = (crumb) =>
  crumb.startsWith('/') ? crumb.toLowerCase() : '/'.concat(crumb.toLowerCase())

const BreadCrumbs = ({ title, breadcrumbs }) => (
  <LocaleContext.Consumer>
    {({ locale }) => {
      const SubFolders = breadcrumbs.map((crumb) => (
        <React.Fragment key={crumb.href}>
          <BreadCrumbItem>
            <Link to={`/${locale}`.concat(formatCrumb(crumb.href))}>
              {capitalizeWord(crumb.label)}
            </Link>
          </BreadCrumbItem>
          <li aria-label="divider">/</li>
        </React.Fragment>
      ))

      return (
        <nav aria-label="breadcrumbs">
          <BreadCrumbsList>
            <BreadCrumbItem>
              <Link to={`/${locale}`}>{lang.home[locale]}</Link>
            </BreadCrumbItem>
            <li aria-label="divider">/</li>
            {SubFolders}
            <BreadCrumbItem aria-current="page">{title}</BreadCrumbItem>
          </BreadCrumbsList>
        </nav>
      )
    }}
  </LocaleContext.Consumer>
)

BreadCrumbs.propTypes = {
  title: PropTypes.string.isRequired,
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
}

BreadCrumbs.defaultProps = {
  breadcrumbs: [],
}

export default BreadCrumbs
